// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"5c5b0bb0","902":"7362c146"}[chunkId] + ".chunk.js";
};